import { Action, action } from 'easy-peasy';

export interface path {
  value: string;
  path: string;
}

export interface IbreadCrumbs {
  path: path[];
  setPath: Action<IbreadCrumbs, path[]>;
}

const breadCrumbs: IbreadCrumbs = {
  path: [],
  setPath: action((state, value) => {
    state.path = value;
  }),
};
export default breadCrumbs;
